/* BSRSTAR V16.2: standalone menu. Does not write to Clarity header-menu state. */
(()=>{
  const init = () => {
    const header = document.querySelector('#header-component');
    if (header && header.dataset.bsrResponsiveBound !== 'true') {
      header.dataset.bsrResponsiveBound = 'true';
      const setDrawerAtNarrowWidths = () => {
        if (window.innerWidth < 990 && header.dataset.menuStyle !== 'drawer') header.dataset.menuStyle = 'drawer';
      };
      setDrawerAtNarrowWidths();
      window.addEventListener('resize', () => requestAnimationFrame(setDrawerAtNarrowWidths));
      new MutationObserver(setDrawerAtNarrowWidths).observe(header,{attributes:true,attributeFilter:['data-menu-style']});
    }
    document.querySelectorAll('[data-bsr-stable-nav]').forEach(nav => {
      if (nav.dataset.bsrBound === 'true') return;
      nav.dataset.bsrBound = 'true';
      const items = Array.from(nav.querySelectorAll('[data-bsr-dropdown]'));
      const timers = new WeakMap();
      const setOpen = (item, open) => {
        const button = item.querySelector('[data-bsr-trigger]');
        const panel = item.querySelector('[data-bsr-panel]');
        if (!button || !panel) return;
        if (open) {
          for (const other of items) if (other !== item) setOpen(other, false);
        }
        item.dataset.open = open ? 'true' : 'false';
        button.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
      };
      const cancel = (item) => {const t = timers.get(item); if (t) clearTimeout(t); timers.delete(item)};
      const closeAfterGrace = (item) => {
        cancel(item);
        timers.set(item,setTimeout(() => {
          if (item.matches(':hover') || item.contains(document.activeElement)) return;
          setOpen(item,false);
        },180));
      };
      for (const item of items) {
        const button = item.querySelector('[data-bsr-trigger]');
        item.addEventListener('mouseenter', () => {cancel(item); setOpen(item,true)});
        item.addEventListener('mouseleave', () => closeAfterGrace(item));
        item.addEventListener('focusin', () => {if (item.dataset.ignoreFocus === 'true') return; cancel(item); setOpen(item,true)});
        item.addEventListener('focusout', (event) => {
          if (event.relatedTarget && item.contains(event.relatedTarget)) return;
          closeAfterGrace(item);
        });
        button?.addEventListener('click', () => {
          cancel(item);
          // Hover has already opened the panel; a click locks it open instead of flickering closed.
          if (item.dataset.open === 'true' && item.dataset.pinned === 'true') {
            item.dataset.pinned = 'false';
            setOpen(item,false);
          } else {
            item.dataset.pinned = 'true';
            setOpen(item,true);
          }
        });
      }
      document.addEventListener('pointerdown', event => {
        if (nav.contains(event.target)) return;
        items.forEach(item => {item.dataset.pinned = 'false';cancel(item);setOpen(item,false)});
      });
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const current = items.find(item => item.dataset.open === 'true');
        if (!current) return;
        event.preventDefault();
        current.dataset.pinned = 'false';
        cancel(current);
        setOpen(current,false);
        if (current.contains(document.activeElement)) {
          current.dataset.ignoreFocus='true';
          current.querySelector('[data-bsr-trigger]')?.focus({preventScroll:true});
          queueMicrotask(() => {delete current.dataset.ignoreFocus});
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
